export default __webpack_public_path__ + "940067d55b5e2ceb451dec582ca78838.png";